import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { trackRegistration } from './util';
import { facebookLogin } from './api';
import ErrorBoundary from './ErrorBoundary';

const ERROR_MESSAGE_GENERIC =
  'There was an error trying to log you in. Please try again.';
const SERVER_SIDE_ERROR =
  "That's not working right now. Please refresh your page or try again later.";
const AUTH_TYPE = 'rerequest';
const SCOPE = ['public_profile', 'email'];
const EXISTING_LOGIN = true;
const FacebookLoginLib = React.lazy(() =>
  import('react-facebook-login/dist/facebook-login-render-props')
);

const FacebookLogin = ({ onSuccess, onFailure, text, setIsLoading }) => {
  const responseCallback = async response => {
    if (!response.accessToken) return;

    setIsLoading(true);
    try {
      const json = await facebookLogin(response);
      if (json.status === true) {
        const gaDimensions =
          'ga_dimensions' in json ? json.ga_dimensions : null;
        if (json.newMember) {
          trackRegistration(
            'signup success facebook',
            'Registered',
            'facebook',
            gaDimensions
          );
          onSuccess();
        } else {
          trackRegistration(
            'login success facebook',
            'Logged In',
            'facebook',
            gaDimensions
          );
          onSuccess(EXISTING_LOGIN);
        }
      } else {
        if (json.message) {
          onFailure(json.message, 0, 'facebook');
        } else {
          onFailure(ERROR_MESSAGE_GENERIC, 0, 'facebook');
        }
      }
    } catch (e) {
      console.error(e);
      onFailure(ERROR_MESSAGE_GENERIC, 0, 'facebook');
    }
  };

  return (
    <ErrorBoundary
      fallback={<div className="server-warning">{SERVER_SIDE_ERROR}</div>}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <FacebookLoginLib
          appId="116999881655243"
          callback={responseCallback}
          scope={SCOPE.join(',')}
          authType={AUTH_TYPE}
          returnScopes
          render={renderProps => (
            <div
              className="socialButtons__facebook font-primary-bold"
              onClick={() => {
                trackRegistration(
                  'login with Facebook click',
                  'Clicked Facebook Login Button'
                );
                renderProps.onClick();
              }}
              role="button"
            >
              <img
                alt=""
                src="https://cdn.education.com/files/static/reg-modal/facebook-logo.png"
              />
              <span>{text}</span>
            </div>
          )}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
FacebookLogin.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  setIsLoading: PropTypes.func.isRequired,
};
export default FacebookLogin;
